import script from "./NavigationSubAccountItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationSubAccountItem.vue?vue&type=script&setup=true&lang=js"

import "./NavigationSubAccountItem.vue?vue&type=style&index=0&id=0481de54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0481de54"]])

export default __exports__